import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {firstValueFrom, fromEvent, merge} from "rxjs";
import {map} from "rxjs/operators";

const filendelse = /.*\.(\w+)$/;
const norskeErstatninger = new Map([['å', 'aa'], ['Å', 'AA'], ['ø', 'oe'], ['Ø', 'OE'], ['æ', 'ae'], ['Æ', 'AE']]);


/** Returnerer angitt størrelse i bytes i nærmeste menneskevennlige benevnelse */
export function formaterFilstørrelse(størrelseBytes: number): string {
    let størrelser = [' Bytes', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
    for (let i = 1; i < størrelser.length; i++) {
        if (størrelseBytes < Math.pow(1024, i)) {
            let justert = Math.round((størrelseBytes / Math.pow(1024, i - 1)) * 10) / 10;
            if (i < 3) justert = Math.round(justert);
            return justert + størrelser[i - 1];
        }
    }
    return størrelseBytes + '';
}

/** Erstatter tegn som er problematiske i filnavn-sammenheng i angitt navn med _.
 * Merk at vi i motsetning til {@link #somSikkertFilnavn}
 * erstatter vi her ikke-ascii-tegn, norske tegn blir erstattet med ren-ascii-kombinasjone (feks å -> aa),
 * øvrige erstattes med _ */
export function somSikkertFilnavnKunAscii(navn: string): string {
    if (erTomEllerNil(navn)) return navn;
    //håndtere norske tegn spesielt
    norskeErstatninger.forEach((erstatning, norskTegn) => navn = navn.replace(norskTegn, erstatning))
    //fjern alle tegn unntatt ascii-bokstaver, tall, space, punktum, underscore og dash
    return navn.replace(/[^\w ._-]+/gu, '_');
}

/** Erstatter tegn som er problematiske i filnavn-sammenheng i angitt navn med _.
 * Tilsvarer java-metode no.systemfabrikken.lederplan.delt.Filer#somSikkertFilnavn */
export function somSikkertFilnavn(navn: string): string {
    if (erTomEllerNil(navn)) return navn;
    //fjern alle tegn unntatt unicode bokstaver, tall, space, punktum, underscore og dash
    return navn.replace(/[^\p{L}\p{Nl}\d ._-]+/gu, '_')
}

export function filendelseFraFile(fil: File): string {
    var endelse = fil.name.match(filendelse);
    return endelse ? endelse[1].toLowerCase() : '';
}

/** Returnerer sann dersom det er mulig å lese angitt fil */
export async function filKanLeses(fil: File): Promise<boolean> {
    if (fil.size == 0) return false;

    // https://developer.mozilla.org/en-US/docs/Web/API/FileReader
    const fileReader = new FileReader();

    // forsøk å lese maks 1kB av filen
    const blob = fil.slice(0, Math.min(fil.size, 1024));

    const leseOk = firstValueFrom(merge(
      fromEvent(fileReader, 'load').pipe(map(() => true)), // Fired when a read has completed successfully.
      fromEvent(fileReader, 'error').pipe(map(() => false)), // Fired when the read failed due to an error.
      fromEvent(fileReader, 'abort').pipe(map(() => true)) //Fired when a read has been aborted, for example because the program called FileReader.abort().
    ));

    // gjør faktisk leseoperasjon
    fileReader.readAsArrayBuffer(blob);

    return await leseOk;
}
